/**
 * @generated SignedSource<<dc6419585d836634e0943640e928b08c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TodoCategoryIcon = "Check" | "Message" | "Order" | "Sun";
export type TodoCategoryCreateScreenMutation$variables = {
  icon: TodoCategoryIcon;
  title: string;
};
export type TodoCategoryCreateScreenMutation$data = {
  readonly todoCategoryCreate: {
    readonly icon: TodoCategoryIcon | null;
    readonly id: string;
    readonly title: string;
  };
};
export type TodoCategoryCreateScreenMutation = {
  response: TodoCategoryCreateScreenMutation$data;
  variables: TodoCategoryCreateScreenMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "icon"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "title"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "icon",
        "variableName": "icon"
      },
      {
        "kind": "Variable",
        "name": "title",
        "variableName": "title"
      }
    ],
    "concreteType": "TodoCategory",
    "kind": "LinkedField",
    "name": "todoCategoryCreate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "icon",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TodoCategoryCreateScreenMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "TodoCategoryCreateScreenMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "7fcee3e4bbb339c31980043a7dafe5e4",
    "id": null,
    "metadata": {},
    "name": "TodoCategoryCreateScreenMutation",
    "operationKind": "mutation",
    "text": "mutation TodoCategoryCreateScreenMutation(\n  $title: String!\n  $icon: TodoCategoryIcon!\n) {\n  todoCategoryCreate(icon: $icon, title: $title) {\n    id\n    title\n    icon\n  }\n}\n"
  }
};
})();

(node as any).hash = "a7b58c964260ae8ba2308abd9830cdc3";

export default node;
